/**
 * Author: Romain Hapi Sr.
 * Version: 1.0
 * Date: 2026-06-25
 * Project: Prenim Digital
 * Copyright: Prenim UK
 */
/**
 * Point d'entree du bundle React.
 *
 * `StrictMode` est volontairement conserve : il monte deux fois les effets en
 * developpement, ce qui a revele les abonnements au defilement laisses sans
 * nettoyage. En production il n'a aucun effet.
 */
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
